<div class="flex justify-between">
  <div class="flex gap-2 justify-start">
    @if (buttonOneTitle) {
      <div class="border border-black rounded" [ngClass]="{'!opacity-50 !pointer-events-none': buttonOneDisabled}">
        <button
          mat-button
          tabindex="0"
          (click)="handleButtonOneClick()"
          [disabled]="buttonOneDisabled"
          >
          {{buttonOneTitle}}
        </button>
      </div>
    }
    @if (buttonTwoTitle) {
      <div class="border border-black rounded" [ngClass]="{'!opacity-50 !pointer-events-none': buttonTwoDisabled}">
        <button
          mat-button
          tabindex="0"
          (click)="handleButtonTwoClick()"
          [disabled]="buttonTwoDisabled"
          >
          {{buttonTwoTitle}}
        </button>
      </div>
    }
  </div>
  @if (buttonThreeTitle) {
    <div class="border border-black !bg-black rounded" [ngClass]="{'!opacity-50 !pointer-events-none': buttonThreeDisabled}">
      <button
        mat-button
        tabindex="0"
        (click)="handleButtonThreeClick()"
        class="!text-white"
        [disabled]="buttonThreeDisabled"
        >
        {{buttonThreeTitle}}
      </button>
    </div>
  }
</div>
